import { render } from "./view-upload.vue?vue&type=template&id=3c0862d0&lang=html"
import script from "./view-upload.vue?vue&type=script&lang=js"
export * from "./view-upload.vue?vue&type=script&lang=js"

import "./view-upload.vue?vue&type=style&index=0&id=3c0862d0&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__